import { useState, useEffect, useCallback } from 'react';
import { adminDashboardService } from '../services/adminDashboardService';

export const useAdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    mainMetrics: null,
    recentActivity: null,
    quickActions: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all dashboard data
  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const data = await adminDashboardService.getCombinedDashboardData();
      
      setDashboardData({
        mainMetrics: data.mainMetrics,
        recentActivity: data.recentActivity,
        quickActions: data.quickActions
      });
    } catch (err) {
      setError(err.message);
      console.error('Failed to fetch dashboard data:', err);
    } finally {
      setLoading(false);
    }
  }, []);


  // Refresh dashboard data
  const refreshDashboard = useCallback(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  // Load dashboard data on mount
  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return {
    dashboardData,
    loading,
    error,
    refreshDashboard
  };
};
